import { Box, Typography } from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import EditIcon from "@mui/icons-material/Edit";
import CustomLoadingScreen from "../../../components/ui/CustomLoadingScreen";
import { useEffect } from "react";
import SearchCG from "./edit/SearchCG";
import SelectCustomer from "./edit/SelectCustomer";
import FileUpload from "./edit/FileUpload";
import Attachments from "./edit/Attachments";
import Comments from "./edit/Comments";
import Summary from "./edit/Summary";
import CreateCG from "./create/CreateCG";
import CreateSelectCustomer from "./create/CreateSelectCustomer";
import CreateFileUpload from "./create/CreateFileUpload";
import CreateAttachments from "./create/CreateAttachments";
import CreateComments from "./create/CreateComments";
import CreateSummary from "./create/CreateSummary";
import CollapseSection from "../../../components/ui/CollapseSection";
import { useDispatch, useSelector } from "react-redux";
import {
	getUserCountries,
	resetAllStates,
	setCGState,
} from "./customerGroupSetupSlice";
import CustomButton from "../../../components/ui/CustomButton";
import MessageSnackbar from "../../../components/ui/MessageSnackbar";
import CreateMessage from "./create/CreateMessage";

const CustomerGroupSetup = () => {
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const { isEdit, isLoading, popUpMsg, popUpSeverity, popUpOpen } = cgState;

	useEffect(() => {
		dispatch(getUserCountries());
		dispatch(resetAllStates({ edit: true }));
	}, []);

	function changeScreen() {
		dispatch(setCGState("isEdit", !isEdit));
		dispatch(resetAllStates({ edit: false }));
	}

	function popMsgOnClose() {
		dispatch(setCGState("popUpOpen", false));
	}

	return (
		<Box>
			<CustomLoadingScreen isLoading={isLoading} />
			<Box>
			<CreateMessage />
			</Box>
			<MessageSnackbar
				message={popUpMsg}
				severity={popUpSeverity}
				open={popUpOpen}
				onClose={popMsgOnClose}
			/>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					mt: 3,
				}}
			>
				<Typography variant="subtitle1" color={"black.main"}>
					{isEdit ? "Search for Customer Group" : "Create Customer Group"}
				</Typography>

				<CustomButton
					startIcon={isEdit ? <NoteAddIcon /> : <EditIcon />}
					onClick={changeScreen}
				>
					{isEdit ? "Create Customer Group" : "Edit Customer Group"}
				</CustomButton>
			</Box>

			{isEdit ? <SearchCG /> : <CreateCG />}

			{isEdit ? <SelectCustomer /> : <CreateSelectCustomer />}
			<CollapseSection title="Attachments">
				{isEdit ? <FileUpload /> : <CreateFileUpload />}

				{isEdit ? <Attachments /> : <CreateAttachments />}
			</CollapseSection>

			<CollapseSection title="Comments">
				{isEdit ? <Comments /> : <CreateComments />}
			</CollapseSection>

			{isEdit ? <Summary /> : <CreateSummary />}
		</Box>
	);
};

export default CustomerGroupSetup;
